export const handleScroll = (e, fetchData, current_page, fetching, next_page_url) => {
	const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
	if (bottom && next_page_url && !fetching) {
		fetchData();
	}
};
